import { makeObservable, observable, action, computed } from "mobx";

/**
 * UIManager is responsible for managing UI-specific states such as rendering,
 * loading, and processing indicators.
 */
export class UIManager {
    private _render: boolean = false;

    private _isBusy: boolean = false;
    private _isBusyMessage: string | null = null;

    private _isLoading: boolean = false;
    private _isLoadingMessage: string | null = null;

    private _isProcessing: boolean = false;
    private _isProcessingMessage: string | null = null;
    constructor() {
        makeObservable<UIManager, "_render" | "_isBusy" | "_isBusyMessage" | "_isLoading" | "_isLoadingMessage" | "_isProcessing" | "_isProcessingMessage">(this, {
            _render: observable,
            _isBusy: observable,
            _isBusyMessage: observable,
            _isLoading: observable,
            _isLoadingMessage: observable,
            _isProcessing: observable,
            _isProcessingMessage: observable,

            setRender: action,
            setBusy: action,
            setIsLoading: action,
            setIsLoadingMessage: action,
            setIsProcessing: action,
            setIsProcessingMessage: action,

            isBusy: computed,
            isLoading: computed,
            isLoadingMessage: computed,
            isProcessing: computed,
            isProcessingMessage: computed,
        });
    }

    public get render(): boolean {
        return this._render;
    }

    public get isBusy(): boolean {
        return this._isBusy;
    }

    public get isBusyMessage(): string | null {
        return this._isBusyMessage;
    }

    public get isLoading(): boolean {
        return this._isLoading;
    }

    public get isLoadingMessage(): string | null {
        return this._isLoadingMessage;
    }

    public get isProcessing(): boolean {
        return this._isProcessing;
    }

    public get isProcessingMessage(): string | null {
        return this._isProcessingMessage;
    }

    public setRender = (value: boolean) => {
        this._render = value;
    };

    public setBusy = (value: boolean) => {
        this._isBusy = value;
    };

    public setIsLoading = (value: boolean) => {
        this._isLoading = value;
    };

    public setIsLoadingMessage = (value: string | null) => {
        this._isLoadingMessage = value;
    };

    public setIsProcessing = (value: boolean) => {
        this._isProcessing = value;
    };

    public setIsProcessingMessage = (value: string | null) => {
        this._isProcessingMessage = value;
    };
}
